import gql from "graphql-tag";

/**
 * Fragment shared by the Orcha and Fides audit configuration queries.
 *
 * Because Fides federates the Orcha GraphQL service, the same shape
 * works for both databases. The `Orcha` vs `Fides` selection is done
 * at the call site (the Super Admin page makes two independent
 * calls, one per backend).
 */
export const auditTableConfigFragment = gql`
  fragment AuditTableConfigFragment on AuditTableConfig {
    schemaName
    tableName
    isEnabled
    excludeColumns
    columns {
      name
      isPrimaryKey
    }
  }
`;
